import Icon from "../base/Icon";
import { PhoneNumberTypes } from "../../core/Enums";
import TwilioLine from "../../modules/voice/lines/models/TwilioLine";
import "./NumberResults.css";


// The numbers a search came back with, and the one being picked.
//
// One component for both places somebody chooses a number: the line wizard inside the product,
// and the phone number step of signing up. They were two copies of the same screen drawn
// differently -- the same search, the same list, one of them years older -- and a customer met
// the old one before they had even finished registering.
//
// No price on a card. It is not known here: what a number costs depends on the plan's allowance
// and how many are already held, and the figure the search returns is the carrier's list price,
// which is not what anybody is charged. Both callers quote the real one where it belongs -- the
// wizard on its confirm step, and sign-up not at all, since the first number is always included.
export default function NumberResults(props: {
    lines?: TwilioLine[],
    selected?: TwilioLine,
    onSelect: (line: TwilioLine) => void
}) {

    const lines = props.lines ?? []

    if (lines.length === 0) return (
        <div className="number-empty">
            <div className="number-empty-icon">
                <Icon icon="phone-rotary" type="solid" size={30} />
            </div>
            <div className="number-empty-title">No numbers matched</div>
            <div className="number-empty-text">
                Try a different area code, or widen the search by clearing part of the number.
            </div>
        </div>
    )

    return (
        <div className="number-results">
            {
                lines.map((item, key) =>
                    <div key={key}
                        className={"number-card" + (props.selected === item ? " is-selected" : "")}
                        onClick={() => props.onSelect(item)}>

                        {
                            props.selected === item &&
                            <div className="number-card-check">
                                <Icon icon="check" type="solid" size={11} />
                            </div>
                        }

                        <div className="number-card-type">
                            {PhoneNumberTypes[item.numberType ?? 1]}
                        </div>

                        <div className="number-card-head">
                            <div className="number-card-number">
                                {item.friendlyName}
                            </div>
                            {
                                item.region &&
                                <div className="number-card-place">
                                    <Icon icon="location-dot" size={11} />
                                    <span>
                                        {item.rateCenter && item.rateCenter !== "" ? item.rateCenter + ", " + item.region : item.region}
                                    </span>
                                </div>
                            }
                        </div>

                        <div className="number-card-caps">
                            <span className={"number-cap" + (item.voice ? "" : " is-off")}
                                title={item.voice ? "Voice enabled" : "Voice not available on this number"}>
                                <Icon icon="phone" type="solid" size={9} />
                                Voice
                            </span>
                            <span className={"number-cap" + (item.sms ? "" : " is-off")}
                                title={item.sms ? "SMS enabled" : "SMS not available on this number"}>
                                <Icon icon="comment-lines" type="solid" size={9} />
                                SMS
                            </span>
                            <span className={"number-cap" + (item.mms ? "" : " is-off")}
                                title={item.mms ? "MMS enabled" : "MMS not available on this number"}>
                                <Icon icon="image" type="solid" size={9} />
                                MMS
                            </span>
                        </div>

                    </div>
                )
            }
        </div>
    )
}
